import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CalendarService } from '../business/ticket-sales/pages/date-selector/calendar/calendar.service';
import { BehaviorSubject, Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface Idioma {
  pkId: string;
  CodIdioma: string;
  Nombre: string;
  Activo: string;
  CentrosIds: string;
  CentrosNombres: string;
}

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  data: any = {};
  // tslint:disable-next-line:variable-name
  public _locale: string;

  public _langDefault: string;

  public filename: string;

  private lastLangSubject: BehaviorSubject<string>;
  public lastLang$: Observable<string>;

  setLocale(value: string) {
    this.lastLangSubject.next(value);
    this._locale = value;
    this.calendarService.setMeses(value);
  }

  setLangDefault(value: string) {
    this._langDefault = value;
  }

  getLocale(): string {
    return this._locale || this._langDefault || 'es-ES';
  }

  getFilename() {
    return this.filename;
  }

  setFilename(value: string) {
    this.filename = value;
  }

  constructor(@Optional() @Inject('TRANS_PARAM') public param: string, private http: HttpClient, private calendarService: CalendarService) {
    this.lastLangSubject = new BehaviorSubject<string>(null);
    this.lastLang$ = this.lastLangSubject.asObservable();

    this.filename = null;
    if (param) {
      this.setFilename(param);
    }
  }

  use(lang: string, proyecto: string): Promise<Record<string, string>> {
    if (lang === 'en') {
      lang = 'en-GB';
    }
    // else if (lang !== 'es-ES' && lang !== 'en-GB' && lang !== 'ca' && lang != 'fr-FR') {
    //    lang = 'es-ES';
    //   }
    return new Promise<Record<string, string>>(resolve => {
      this.fileLangExists(lang, proyecto).subscribe(existsLangPath => {
        if (!existsLangPath) {
          lang = this._langDefault || 'es-ES';
        }
        this.setLocale(lang);
        let thefile;
        if (this.getFilename()) thefile = this.getFilename() + '_' + (lang || this._langDefault || 'es-ES');
        const langPath = `./assets/i18n/${proyecto}/${thefile || lang || this._langDefault || 'es-ES'}.json`;
        this.http.get<Record<string, string>>(langPath).subscribe(
          translation => {
            this.data = Object.assign({}, translation || {});
            // this.calendarService.setMeses(this.getLocale());
            resolve(this.data);
          },
          () => {
            this.data = {};
            resolve(this.data);
          }
        );
      });
    });
  }

  fileLangExists(lang: string, proyecto: string) {
    const url = `./assets/i18n/${proyecto}/${lang}.json`;
    return this.fileExists(url);
  }

  fileExists(url: string): Observable<boolean> {
    return this.http.get(url).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  changeLanguageCookieOneTrust(lang_: string) {
    let lang = lang_;

    if (!lang) {
      return;
    }

    switch (lang) {
      case 'es-ES':
        lang = 'es';
        break;
      case 'en-GB':
        lang = 'en';
        break;
      case 'ca':
        lang = 'ca';
        break;
      case 'fr-FR':
        lang = 'fr';
        break;
      default:
        lang = 'es';
        break;
    }

    document.documentElement.lang = lang;

    // Recargar OneTrust
    if (window['OneTrust'] && window['OneTrust'].ToggleInfoDisplay) {
      // console.log(window.OneTrust);
      window['OneTrust'].changeLanguage(lang);
    }
  }

  checkTranslationFile(lang: string, proyecto: string): Observable<boolean> {
    const url = `assets/i18n/${proyecto}/${lang}.json`;

    return this.http.get(url).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  filterAvailableLanguages(languages: Idioma[], proyecto: string): Observable<Idioma[]> {
    const isTranslationFileExists = languages.map(lang => {
      return this.checkTranslationFile(lang.CodIdioma, proyecto).pipe(
        map(exist => ({ lang: lang, exist })),
        catchError(() => of({ lang: lang, exist: false }))
      );
    });

    return forkJoin(isTranslationFileExists).pipe(map(results => results.filter(r => r.exist).map(r => r.lang)));
  }
}
